import React, { useState } from 'react';
import radioChecked from '../../common/Images/radio_button_checked.svg';
import radioUnchecked from '../../common/Images/radio_button_unchecked.svg';

const RadioFilter = ({ value, filterConfig, onChange }) => {
    const [checkedValue, setCheckedValue] = useState(value);

    const onClick = (newVal) => {
        setCheckedValue(newVal);
        onChange(newVal);
    };

    const options = filterConfig.options.map((option) => {
        return (
            <div
                key={`radioSelectOption_${option.value}`}
                id={`radioSelectOption_${option.value}`}
                className="p-1.5 text-normal cursor-pointer flex items-center"
                onClick={(event) => onClick(option.value)}>
                {option.value === checkedValue && <img src={radioChecked} alt="" />}
                {option.value !== checkedValue && <img src={radioUnchecked} alt="" />}
                <div className="mx-1.5">{option.label}</div>
            </div>
        );
    });

    return (
        <div className="items-center">
            <div>{options}</div>
        </div>
    );
};

export default RadioFilter;
